<template>
  <transition name="modal">
    <div class="modal-container">
      <div class="center-box">
        <div class="spinner-wrap">
          <i class="fa-3x fas fa-spinner fa-spin"></i>
        </div>
        <div class="msg-wrap">
          <slot name="message">
            <p class="msg">{{message}}</p>
          </slot>
        </div>
      </div>
      <div class="modal-backdrop">
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">

interface Props {
  message?: string;
}

withDefaults(defineProps<Props>(), {
  message: 'データロード中...',
});
</script>

<style lang="scss" scoped>
  .modal-container {
    position: relative;
    z-index: 9999;
  }
  .center-box {
    position: fixed;
    top: 40vh;
    left: 0;
    width: 100vw;
    font-size: 24px;
    text-align: center;

    .fa-spinner {
      color: #333333;
    }
    .msg-wrap {
      font-size: 30px;
      white-space: nowrap;
      margin: 10px 0 0 0;
    }
  }
  .modal-backdrop {
    opacity: 0.2;
  }

  .modal-enter {
    opacity: 0;
  }
  .modal-enter-active {
    transition: opacity .0s ease;
  }
  .modal-enter-to {
    opacity: 1.0;
  }
  .modal-leave-active {
    transition: opacity .3s ease;
  }
</style>
